import { PermissionCheckerService } from '@abp/auth/permission-checker.service';
import { DOCUMENT } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Inject, Injector, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { LayoutRefService } from '@metronic/app/core/services/layout/layout-ref.service';
import { AppComponentBase } from '@shared/common/app-component-base';
import { takeUntilDestroyed } from '@shared/rxjs-extensions/takeUntilDestroyed';
import { TenantServiceProxy } from '@shared/service-proxies/service-proxies';
import { filter } from 'rxjs/operators';
import { AppMenu } from './app-menu';
import { AppNavigationService } from './app-navigation.service';
import { AssessmentServiceProxy, SaveCustomerTokenInput } from '@shared/service-proxies/service-proxies';

@Component({
    templateUrl: './side-bar-menu.component.html',
    selector: 'side-bar-menu',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SideBarMenuComponent extends AppComponentBase implements OnInit, AfterViewInit {

    menu: AppMenu = null;

    currentRouteUrl = '';
    insideTm: any;
    outsideTm: any;
    customizedLocalization: { [key: string]: string; };
    frm_notification_count = 0;

    constructor(
        injector: Injector,
        private el: ElementRef,
        private router: Router,
        private layoutRefService: LayoutRefService,
        public permission: PermissionCheckerService,
        private _appNavigationService: AppNavigationService,
        private _tenantServiceProxy: TenantServiceProxy,
        private _assessmentService: AssessmentServiceProxy,
        @Inject(DOCUMENT) private document: Document) {
        super(injector);
    }

    ngOnInit() {
        this.menu = this._appNavigationService.getMenu();
        // this._tenantServiceProxy.getCustomizedLocalization().subscribe(s => {
        //     this.customizedLocalization = s;
        // });        
        this.currentRouteUrl = this.router.url.split(/[?#]/)[0];

        this.router.events
            .pipe(takeUntilDestroyed(this))
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(event => this.currentRouteUrl = this.router.url.split(/[?#]/)[0]);

        //this.frm_notification_count = 0;
        //this.Get_UserFormsCount();
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.layoutRefService.addElement('asideLeft', this.el.nativeElement);
        });
    }

    getMenuName(key: string, originalLocalizationValue: string) {
        let value = this.customizedLocalization !== undefined ? this.customizedLocalization[key] : undefined;

        return value !== undefined && value !== null && value.length > 0 ? value : originalLocalizationValue;
    }

    showMenuItem(menuItem): boolean {

        return this._appNavigationService.showMenuItem(menuItem);
    }

    isMenuItemIsActive(item): boolean {
        if (item.items.length) {
            return this.isMenuRootItemIsActive(item);
        }

        if (!item.route) {
            return false;
        }

        // dashboard
        if (item.route !== '/' && this.currentRouteUrl.startsWith(item.route)) {
            return true;
        }

        return this.currentRouteUrl.replace(/\/$/, '') === item.route.replace(/\/$/, '');
    }

    isMenuRootItemIsActive(item): boolean {
        let result = false;

        for (const subItem of item.items) {
            result = this.isMenuItemIsActive(subItem);
            if (result) {
                return true;
            }
        }

        return false;
    }

    /**
	 * Use for fixed left aside menu, to show menu on mouseenter event.
	 * @param e Event
	 */
    mouseEnter(e: Event) {
        if (!this.currentTheme.baseSettings.menu.allowAsideMinimizing) {
            return;
        }

        // check if the left aside menu is fixed
        if (this.document.body.classList.contains('m-aside-left--fixed')) {
            if (this.outsideTm) {
                clearTimeout(this.outsideTm);
                this.outsideTm = null;
            }

            this.insideTm = setTimeout(() => {
                // if the left aside menu is minimized
                if (this.document.body.classList.contains('m-aside-left--minimize') && mUtil.isInResponsiveRange('desktop')) {
                    // show the left aside menu
                    this.document.body.classList.remove('m-aside-left--minimize');
                    this.document.body.classList.add('m-aside-left--minimize-hover');
                }
            }, 300);
        }
    }

    /**
     * Use for fixed left aside menu, to show menu on mouseenter event.
     * @param e Event
     */
    mouseLeave(e: Event) {
        if (!this.currentTheme.baseSettings.menu.allowAsideMinimizing) {
            return;
        }

        if (this.document.body.classList.contains('m-aside-left--fixed')) {
            if (this.insideTm) {
                clearTimeout(this.insideTm);
                this.insideTm = null;
            }

            this.outsideTm = setTimeout(() => {
                // if the left aside menu is expand
                if (this.document.body.classList.contains('m-aside-left--minimize-hover') && mUtil.isInResponsiveRange('desktop')) {
                    // hide back the left aside menu
                    this.document.body.classList.remove('m-aside-left--minimize-hover');
                    this.document.body.classList.add('m-aside-left--minimize');
                }
            }, 500);
        }
    }

    // Get_UserFormsCount() {
        
    //     this._appNavigationService.getUserTenantInfo();
    //     let input = new SaveCustomerTokenInput();
    //     input.companyId = localStorage.getItem('forms_companyId');        
    //     input.userRole = localStorage.getItem('forms_userrole');

    //     var tenantId = localStorage.getItem('forms_tenantId');
    //     if (tenantId != "" && tenantId != null && tenantId != "null") {
            
    //         input.tenantId = Number.parseInt(tenantId);
    //         input.userId = Number.parseInt(localStorage.getItem('forms_userId'));
    //         this._tenantServiceProxy.userFormsCount(input).subscribe(resp => {
    //             this.frm_notification_count = Number(resp.formsCount);
    //         });
    //     }
    // }
}
